export function openTab(url: string): Window | null {
  // eslint-disable-next-line no-restricted-globals
  return window.open(url, '_blank');
}
